// extracted by mini-css-extract-plugin
export default {"badges":"EducationTagInfo-module--badges--46495"};